<template>
    <!-- 团队成员 -->
    <div class="member">
        <div class="title-warp flex-align-between">
            <h3 class="title">团队成员</h3>
            <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage" :small="true"
                :limit.sync="pages.pageSize" :pageSizes="[8,16,24]" :layout="'prev,pager,next'"
                @pagination="handlePageChange">
            </pagination>
        </div>
        <ul class="member-list">
            <li v-for="(item,index) in memberList" :key="index" class="member-item flex-layout">
                <img src="../../assets/studio/image-1.png" alt="" class="member-avatar">
                <div class="info">
                    <p class="member-name">王彦伟</p>
                    <p class="member-desc">东城区教师研修中心教研员，正高级教师，北京特级教师
                        东城区教师研修中心教研员，正高级教师，北京特级</p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                pages: { //分页
                    currentPage: 1,
                    pageSize: 8,
                    total: 30,
                },
                memberList: [{
                        avatar: require("../../assets/studio/image-1.png"),
                        name: '王彦伟',
                        desc: '东城区教师研修中心教研员，正高级教师，北京特级教师东城区教师研修中心教研员，正高级教师，北京特级教师东城区教师研修中心教研员，正高级教师，北京特级教师东城区教师研修中心教研员，正高级教师，北京特级教师'
                    },
                    {
                        avatar: require("../../assets/studio/image-1.png"),
                        name: '王彦伟',
                        desc: '东城区教师研修中心教研员，正高级教师，北京特级教师东城区教师研修中心教研员，正高级教师，北京特级教师东城区教师研修中心教研员，正高级教师，北京特级教师东城区教师研修中心教研员，正高级教师，北京特级教师'
                    }, {
                        avatar: require("../../assets/studio/image-1.png"),
                        name: '王彦伟',
                        desc: '东城区教师研修中心教研员，正高级教师，北京特级教师东城区教师研修中心教研员，正高级教师，北京特级教师东城区教师研修中心教研员，正高级教师，北京特级教师东城区教师研修中心教研员，正高级教师，北京特级教师'
                    }
                ]
            }
        },
        methods: {
            handlePageChange() {}
        },
    }
</script>

<style lang="less" scoped>
    .title-warp {
        border-bottom: 1px solid #648BEC;
        padding-bottom: 14px;
    }

    .title {
        background-color: #7084D7;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: 24px;
        line-height: 2.1;
        color: #fff;
        font-weight: bold;
        padding: 0 3.7% 0 6.2%;
        width: 21%;
        box-sizing: border-box;
        position: relative;

        &::before {
            content: " ";
            width: 28px;
            height: 48px;
            background-image: url("../../assets/studio/Icon_Bookmark.png");
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 14px;
        }
    }

    /deep/ .pagination {
        text-align: right;

        .el-pagination {

            .btn-prev,
            .btn-next {
                background-color: #7084D7;
                color: #fff;
                padding: 0 6px;
                min-width: 28px;
            }
        }
    }

    .member-list {
        padding: 5% 0 0 0;
        font-size: 18px;
        line-height: 2.2;

        .member-item {
            background-color: RGBA(241, 244, 245, 1);
            margin-bottom: 4.1%;
        }

        .member-avatar {
            width: 23%;
            max-height: 250px;
            flex-shrink: 0;
            margin-right: 4.4%;
        }

        .member-name {
            font-size: 30px;
            line-height: 2.9;
        }

        .member-desc {
            font-size: 24px;
            line-height: 1.6;
            font-weight: 300;
            padding-right: 8%;

        }
    }
</style>